import type { FaireProductEntity } from "../../entity_types/product";

export const p_2zc3faxr49: FaireProductEntity = {
  token: "p_2zc3faxr49",
  type: "product",
  name: "Caribbean Calcite aka Blue Aragonite Sphere Set 193g/50.9mm",
  brandToken: "b_hjv6mwysyg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1cb1f3466afc95c06707af34783c2423c60802231ec2a82175cf2f2a583524f2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/778fa5af94b59273a1ffa73a70bad8b5db41ebfe899c936e9773ded136a98f04.jpeg",
    "https://cdn.faire.com/fastly/7068c8a7da79b00282fae9fafb9379f49ed2073a668706c9ea26fb18f8743465.jpeg",
    "https://cdn.faire.com/fastly/59c6232e90637c154e56dfc4a02c48494bfbd784458d41598077a6bce40ef82a.jpeg",
    "https://cdn.faire.com/fastly/ec91c80cee79da29f4e6c49e6fae56a7c16243356fcb1fe0b9c2366d6dc164b6.jpeg",
  ],
  priceDollars: 22.87,
  description:
    "Caribbean Calcite Crystal Sphere Gift Set with Selenite Piece for cleansing and clearing is a metaphysical healing product that combines the powerful energies of Caribbean Calcite and Selenite to promote emotional balance, stress relief, and spiritual growth. Caribbean Calcite helps us access our inner vision and connect to our higher selves, to gain a sense of purpose, a true sense of self, and begin a journey of ultimate self-discovery. It is a helpful stone during times of new beginnings and personal growth. A calming stone, Caribbean Calcite encourages us to live in the present moment. Selenite is a powerful stone that is known for its ability to cleanse and clear the mind and body of negative energy. It is also believed to promote emotional balance, stress relief, and spiritual growth. \n\nSet Includes:\nCaribbean Calcite sphere\nAcrylic Stand\nSelenite Piece\nInformational Cards\n\n***Please note that these are natural items and will have natural lines and inclusions.",
  tags: [],
  msrpDollars: 45.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:16.333Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
